import { Link, styled } from "@mui/material";
import NextLink from "next/link";
export const InlineLink = styled(Link)(({ theme }) => ({
    color: "inherit",
    textDecoration: "underline",
    textUnderlineOffset: theme.textUnderlineOffset,
    "&:hover": { opacity: 0.75 },
}));
export const InternalInlineLink = styled(NextLink)(({ theme }) => ({
    color: "inherit",
    textDecoration: "underline",
    textUnderlineOffset: theme.textUnderlineOffset,
    "&:hover": { opacity: 0.75 },
}));
//# sourceMappingURL=inline-link.js.map